














































import Vue from 'vue';
import { debounce, orderBy } from 'lodash';
import { errorToMessage } from '@/core/utils/errors';

interface LocalState {
  customers: PaginatedResponse<CustomerResponse> | null;
  selectedCustomer: CustomerResponse | null;
  expirationDate: Date | null;
  amountPaid: number | null;
  isSaving: boolean;
}
export default Vue.extend({
  name: 'AddCustomerToProductModal',
  data(): LocalState {
    return {
      customers: null,
      selectedCustomer: null,
      expirationDate: null,
      amountPaid: null,
      isSaving: false,
    };
  },
  computed: {
    productId(): number {
      return parseInt(this.$route.params['id']);
    },
  },
  async mounted(): Promise<void> {
    this.customers = await this.$store.dispatch('sale/getSalesCustomers');
    if (this.customers) this.orderCustomers(this.customers);
  },
  methods: {
    orderCustomers(customers: PaginatedResponse<CustomerResponse>): void {
      customers.results = orderBy(customers.results, ['full_name'], ['asc']);
    },
    async onConfirm(): Promise<void> {
      if (this.selectedCustomer) {
        const c = this.selectedCustomer;
        try {
          this.isSaving = true;
          await this.$store.dispatch('sale/enrollCustomer', {
            customer_id: c.id,
            product_id: this.productId,
            expiration_date: this.expirationDate || null,
            amount_paid: this.amountPaid || null,
          });
          this.$notify({
            group: 'app',
            type: 'success',
            title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
            text: this.$t('CUSTOMERS.NOTIFICATIONS.CUSTOMER_ENROLL_SUCCESS'),
          });
        } catch (error) {
          this.$notify({
            group: 'app',
            type: 'error',
            title: this.$t('CUSTOMERS.NOTIFICATIONS.CUSTOMER_ENROLL_ERROR'),
            text: errorToMessage(error?.response, `Request failed: ${error}`),
            duration: -1, // stay ON
          });
        } finally {
          this.isSaving = false;
        }
      }
      this.$emit('close');
    },
    search: debounce(async function (this, query) {
      this.customers = await this.$store.dispatch('sale/getSalesCustomers', {
        q: query,
      });
      if (this.customers) this.orderCustomers(this.customers);
    }, 300),
  },
});
